import * as Scrivito from "scrivito";
import metadataAttributes from "objs/_metadataAttributes";
import defaultPageAttributes from "objs/_defaultPageAttributes";

const ProductConfigurator = Scrivito.provideObjClass("ProductConfigurator", {
  attributes: {
    body: ["widgetlist", { only: "SectionWidget" }],
    ...metadataAttributes,
    ...defaultPageAttributes,
  },
  extractTextAttributes: ["body", "title", "subtitle"],
});

export default ProductConfigurator;
